import React from "react"
import { generatePath, Link } from "react-router-dom"
import { Tag, Typography } from "antd"
import { ColumnsType } from "antd/es/table"
import Tippy from "@tippyjs/react"

import { NoContent } from "@src/app/components/NoContent/Index"
import { IdItem } from "@src/app/components/tableRowItems/idItem"
import css from "@src/app/components/tableRowItems/idItem/index.module.css"
import { paths } from "@src/app/paths"
import {
  BankPayoutResponse,
  BankPayoutResponseStatusEnum,
  InvoiceResponseStatusEnum,
  MassPayoutShort,
} from "@src/shared/api/generated"
import { DateTimeTableCell } from "@src/shared/componemts/DateTimeTableCell"
import {
  filtersPresets,
  getFilterSimpleFiled,
} from "@src/shared/componemts/TableFilter/classes/constants"

export const TransactionsBanksPayouts = [
  getFilterSimpleFiled("externalId").search({
    col: 8,
    placeholder: "Search for External ID",
  }),
  getFilterSimpleFiled("date").date({ col: 10, label: "Date" }),
  { ...filtersPresets.order, col: 6 },
]
export const TransactionsBanksPayoutsColumns: ColumnsType<BankPayoutResponse> =
  [
    {
      dataIndex: "id",
      render: (_, { id }) => <IdItem id={id} />,
      title: "ID",
    },
    {
      dataIndex: "created_at",
      render: (_, { created_at }) => <DateTimeTableCell value={created_at} />,
      title: "Date and Time",
    },
    {
      dataIndex: "external_id",
      title: "External ID",
    },
    {
      dataIndex: "status",
      render: (_, { status }) => {
        const cMap = {
          [BankPayoutResponseStatusEnum.Completed]: "green",
          [BankPayoutResponseStatusEnum.Failed]: "error",
          [BankPayoutResponseStatusEnum.Pending]: "geekblue",
          [BankPayoutResponseStatusEnum.Sending]: "geekblue",
        }

        return <Tag color={cMap[status] ?? "geekblue"}>{status}</Tag>
      },
      title: "Status",
    },
    {
      dataIndex: "amount",
      render: (_, { data }) => (
        <Typography.Text style={{ fontWeight: "bold" }}>
          {data.amount}
        </Typography.Text>
      ),
      title: "Amount",
    },
    {
      dataIndex: "symbol",
      render: (_, { data }) => <Typography.Text>{data.symbol}</Typography.Text>,
      title: "Symbol",
    },
    {
      render: (_, record) => {
        if (!record.data.fees) {
          return "—"
        }

        return `${record.data.fees.total_fee || "-"}`
      },
      title: "Fee",
    },
    {
      render: (_, { data }) => {
        return `${data.account.number || "-"}`
      },
      title: "Account number",
    },
    {
      render: (_, { data }) => {
        return `${data.account.country || "-"}`
      },
      title: "Country",
    },
    {
      render: (_, { data }) => {
        return `${data.account.type || "-"}`
      },
      title: "Type",
    },
    {
      render: (_, { data }) => {
        return `${data.account.bank_id || "-"}`
      },
      title: "Bank ID",
    },
    {
      render: (_, data) => {
        if (!data.error) {
          return "-"
        }

        return (
          <Tippy
            className={css.tooltip}
            content={data.error.message}
            placement="top-start"
          >
            <Tag color="error" style={{ cursor: "help" }}>
              {data.error.code}
            </Tag>
          </Tippy>
        )
      },
      title: "Error ID",
    },
  ]
